export function userType(Urls){
    
    let thisUser = {
          readonly: false
    }
    const securityGuids = $.sc.authSettings.securityGroups;

    // Read only users who are not LA Org and SAG
    if (securityGuids.indexOf(Urls.readOnlySecurityGroup) > -1 && ($.sc.authSettings.isOriginalPrincipalOrgAdmin === false && $.sc.authSettings.isOriginalPrincipalSag === false) ) {
        thisUser.readonly = true;
    }

    return thisUser;

}